import React from 'react';
import { OptimizelyContentReference, OptimizelyLinkCollection } from "../../../types/optimizely/blocks";
import PagePreview from "./PagePreview";

interface PreviewColumnProps {
    column: {
        article?: OptimizelyContentReference;
        links?: OptimizelyLinkCollection;
    };
    renderType: number;
    showBackground: boolean;
    columnsCount: number;
}

const PreviewColumn: React.FC<PreviewColumnProps> = ({ column, renderType, showBackground, columnsCount }) => {
    const { article } = column;
    const page = article?.expandedValue;

    if (!page) {
        return <div />;
    }

    return (
        <PagePreview
            page={page}
            renderType={renderType}
            showBackground={showBackground}
            columnsCount={columnsCount}
        />
    );
};

export default PreviewColumn;
